import Scene from './../../components/scene/Scene';
import { useAppStore } from './../../hooks/store/useAppStore';
import { tourActiveSceneIndexSelector } from './../../hooks/store/getters';
import { useHistory } from "react-router-dom";

const CreateScene = () => {
    
    const tourActiveSceneIndex = useAppStore(tourActiveSceneIndexSelector);
    const history = useHistory();
    
    if (tourActiveSceneIndex === null) {
        history.push("/create-tour/tour-info");
        return null;
    }
    
    return (
        <Scene />
    );
    
};

export default CreateScene;